export default class PendingRequestViewModel {
  pendingRegisterText = 'Solicitud registrada';
  pendingAlertText = 'PENDIENTE DE VERIFICACIÓN';
  // eslint-disable-next-line max-len
  pendingInfoText = 'Manténgase a la espera. En breves mostraremos el resultado de la verificación';
  // eslint-disable-next-line max-len
  // pendingInfoText = 'Manténgase a la espera. En breves enviaremos un correo con el resultado de la verificación';
}
